import Model from 'flarum/common/Model';
/**
 * Frontend model for the `waterfall-sets` JSON:API resource.
 *
 * A set groups every image chosen in one upload. The grid renders one card per
 * set (cover image + image count badge) and the lightbox browses its `images`
 * in the uploader-defined `position` order.
 */
export default class WaterfallSet extends Model {
  title() {
    return Model.attribute('title').call(this);
  }
  tags() {
    return Model.attribute('tags', value => value ?? []).call(this);
  }
  imagesCount() {
    return Model.attribute('imagesCount', value => value ?? 0).call(this);
  }
  likesCount() {
    return Model.attribute('likesCount', value => value ?? 0).call(this);
  }
  viewsCount() {
    return Model.attribute('viewsCount', value => value ?? 0).call(this);
  }
  score() {
    return Model.attribute('score', value => value ?? 0).call(this);
  }
  status() {
    return Model.attribute('status', value => value ?? 'pending').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  canRename() {
    return Model.attribute('canRename').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  coverImage() {
    return Model.hasOne('coverImage').call(this);
  }
  images() {
    return Model.hasMany('images').call(this);
  }

  /**
   * The image rendered as the card cover (falls back to the first loaded
   * image when the server has not resolved a cover yet).
   */
  cover() {
    const cover = this.coverImage();
    if (cover) {
      return cover;
    }
    const images = this.images();
    return images && images[0] || null;
  }
}
flarum.reg.add('lcoy-waterfall', 'common/models/WaterfallSet', WaterfallSet);